import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Unavailable from 'modules/payroll_integrations_a3innuva/components/Incidence/Unavailable'
import type { Sync } from 'modules/payroll_integrations_a3innuva/lib/IncidenceSync/store'
import { Status } from 'modules/payroll_integrations_a3innuva/lib/IncidenceSync/store'

import Available from './Available'
import Done from './Done'

interface Props {
  sync: Sync
  syncing: boolean
  onSync: () => void
}

const Hiring = ({ sync, syncing, onSync }: Props) => {
  const syncContent = (sync: Sync, syncing: boolean, onSync: () => void) => {
    switch (sync.status) {
      case Status.Available:
        return <Available onSync={onSync} syncing={syncing} />
      case Status.Unavailable:
        return <Unavailable sync={sync} />
      case Status.Done:
        return <Done />
      default:
        throw new Error(`Rendering unknown status ${sync.status}`)
    }
  }

  const background = (sync: Sync) => {
    switch (sync.status) {
      case Status.Available:
        return 'grey200'
      case Status.Unavailable:
        return 'white'
      case Status.Done:
        return 'viridian200'
      default:
        throw new Error(`Rendering unknown status ${sync.status}`)
    }
  }

  return (
    <Box
      background={background(sync)}
      paddingX="s24"
      paddingY="s16"
      borderRadius={{
        all: 'abs008',
      }}
      gap="s16"
    >
      {syncContent(sync, syncing, onSync)}
    </Box>
  )
}

export default Hiring
